<template>
  <div class="top-bar view-mode-comp">
    <select v-model="leftMovieListId" class="custom-select ml-select ib"
        @change="$emit('change-movie-list-id', 'left')">
      <option v-for="e in leftMovieLists" :key="e.id" :value="e.id">
        {{e.dateLocationCarDisp}}
      </option>
    </select>
    <div class="btn-group movie-search-btn-wrap">
      <div class="btn-group">
        <button type="button" class="btn btn-secondary"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fas fa-angle-double-left fa-lg"></i>
        </button>
        <div class="dropdown-menu">
          <div class="dropdown-item disabled ft-bold">
            {{dtFormat(leftBaseDate, 'yyyy/mm/dd')}}
          </div>
          <div class="dropdown-divider"></div>
          <div class="dropdown-item" v-for="(v, i) in MOVIE_BACK_DATE_CHOICES" :key="i"
              @click="$emit('search-by-date-range', 'left', v.key)">
            {{v.val}}
          </div>
        </div>
      </div>
      <div class="btn-group">
        <button type="button" class="btn btn-secondary"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fas fa-angle-double-right fa-lg"></i>
        </button>
        <div class="dropdown-menu">
          <div class="dropdown-item disabled ft-bold">
            {{dtFormat(leftBaseDate, 'yyyy/mm/dd')}}
          </div>
          <div class="dropdown-divider"></div>
          <div class="dropdown-item" v-for="(v, i) in MOVIE_FORWARD_DATE_CHOICES" :key="i"
              @click="$emit('search-by-date-range', 'left', v.key)">
            {{v.val}}
          </div>
        </div>
      </div>
    </div>
    <div class="btn-group btn-group-toggle ws-nowrap" style="margin-top:-1px;">
      <label class="btn btn-info btn-md" v-for="(e, i) in cameraPositions"
          :class="{active: selectedCameraPosition === e.camPos}" :key="i">
        <input type="radio" name="options"
        :checked="selectedCameraPosition === e.camPos"
        autocomplete="off" @click="$emit('change-camera-position', e.camPos)">{{e.disp}}
      </label>
    </div>
    <select v-model="rightMovieListId" class="custom-select ml-select ib"
        @change="$emit('change-movie-list-id', 'right')">
      <option v-for="e in rightMovieLists" :key="e.id" :value="e.id">
        {{e.dateLocationCarDisp}}
      </option>
    </select>
    <div class="btn-group movie-search-btn-wrap">
      <div class="btn-group">
        <button type="button" class="btn btn-secondary"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fas fa-angle-double-left fa-lg"></i>
        </button>
        <div class="dropdown-menu">
          <div class="dropdown-item disabled ft-bold">
            {{dtFormat(rightBaseDate, 'yyyy/mm/dd')}}
          </div>
          <div class="dropdown-divider"></div>
          <div class="dropdown-item" v-for="(v, i) in MOVIE_BACK_DATE_CHOICES" :key="i"
              @click="$emit('search-by-date-range', 'right', v.key)">
            {{v.val}}
          </div>
        </div>
      </div>
      <div class="btn-group">
        <button type="button" class="btn btn-secondary"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fas fa-angle-double-right fa-lg"></i>
        </button>
        <div class="dropdown-menu">
          <div class="dropdown-item disabled ft-bold">
            {{dtFormat(rightBaseDate, 'yyyy/mm/dd')}}
          </div>
          <div class="dropdown-divider"></div>
          <div class="dropdown-item" v-for="(v, i) in MOVIE_FORWARD_DATE_CHOICES" :key="i"
              @click="$emit('search-by-date-range', 'right', v.key)">
            {{v.val}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="toggle-button mr16">
    <div class="btn-group btn-group-toggle ws-nowrap">
      <label class="btn btn-info btn-sm">
        <input type="radio" name="options"
          autocomplete="off" @click="$emit('switch-to-full-mode')">三面
      </label>
      <label class="btn btn-info btn-sm active">
        <input type="radio" name="options" checked="" autocomplete="off">比較
      </label>
    </div>
  </div>
  <div class="close-button" @click="$emit('close')">
    <i class="fas fa-times fa-2x"> </i>
  </div>
</template>

<script setup lang="ts">
import type { GIMovieList } from 'src/models/geoItem';
import type { CameraPosition } from 'src/models/movie';
import type { LeftRight } from 'src/models/moviePlayer';
import { dtFormat } from 'src/lib/dateHelper';
import {
  MOVIE_BACK_DATE_CHOICES,
  MOVIE_FORWARD_DATE_CHOICES,
} from 'src/components/lib/MoviePlayerCompareMode/composables/useMoviePlayerCompareModeState';

interface Props {
  leftMovieLists: GIMovieList[];
  rightMovieLists: GIMovieList[];
  leftBaseDate: Date | null;
  rightBaseDate: Date | null;
  selectedCameraPosition: CameraPosition;
}

defineProps<Props>();

const cameraPositions: Array<{ camPos: CameraPosition; disp: string }> = [
  { camPos: 'left', disp: '左' },
  { camPos: 'front', disp: '正面' },
  { camPos: 'right', disp: '右' },
];

const leftMovieListId = defineModel<string>('leftMovieListId', { required: true });
const rightMovieListId = defineModel<string>('rightMovieListId', { required: true });

defineEmits<{
  (e: 'change-movie-list-id', lr: LeftRight): void;
  (e: 'search-by-date-range', lr: LeftRight, dateOffset: number): void;
  (e: 'change-camera-position', pos: CameraPosition): void;
  (e: 'switch-to-full-mode'): void;
  (e: 'close'): void;
}>();
</script>

<style lang="scss" scoped>
.top-bar {
  flex-grow: 1;
  &.view-mode-comp {
    padding-left: 120px;
    display: flex;
    justify-content: center;
    font-size: 1.1rem;
    .ml-select {
      flex-grow: 1;
      max-width: 600px;
      padding: 2px 6px;
      height: 32px;
      margin: 1px 12px 0 24px;
    }
  }
}
.close-button {
  width: 30px;
  text-align: center;
  cursor: pointer;
}
</style>
